import { render } from "./Business_B.vue?vue&type=template&id=69da8c7a&scoped=true"
import script from "./Business_B.vue?vue&type=script&lang=js"
export * from "./Business_B.vue?vue&type=script&lang=js"

import "./Business_B.vue?vue&type=style&index=0&id=69da8c7a&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69da8c7a"]])

export default __exports__